import React, { useEffect } from 'react'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

am4core.useTheme(am4themes_animated)

function Pictorial({ data, matches }) {
	
	useEffect(
		() => {
			// Map instance
			const chart = am4core.create('chartdivpic', am4charts.SlicedChart)
			chart.data = data

			var title = chart.titles.create();
			title.text = "Desagregado de avance de ejecución";
			title.fontSize = 14;
			title.fontWeight = "bolder";
			title.align = "left";
			
			chart.responsive.enabled = matches ? true : false
			chart.data[0].color = am4core.color('#ff7043')
			chart.data[1].color = am4core.color('#ffb74d')
			chart.data[2].color = am4core.color('#ffee58')
			chart.data[3].color = am4core.color('#6fb258')
			chart.data[4].color = am4core.color('#5faa46')
			chart.data[5].color = am4core.color('#55993f')

			var man =
				'M1337.5,322H22.5A10.5,10.5,0,0,1,12,311.5v-23A10.5,10.5,0,0,1,22.5,278h1315a10.5,10.5,0,0,1,10.5,10.5v23A10.5,10.5,0,0,1,1337.5,322Z'
			var series = chart.series.push(new am4charts.PictorialStackedSeries())
			series.orientation = 'horizontal'

			series.dataFields.value = 'value'
			series.dataFields.category = 'name'
			series.alignLabels = true
			series.slices.template.propertyFields.fill = 'color'
			series.slices.template.propertyFields.stroke = 'color'
			series.labels.template.text = '[bold]{name}[/]\n{value} municipios'
			series.labels.template.wrap = true
			series.labels.template.fontSize = 12
			series.labels.template.dx = 100
			series.labels.template.rotation = -360

			series.maskSprite.path = man

			return function cleanup() {
				chart && chart.dispose()
			}
		},
		[ data, matches ]
	)

	return <div id="chartdivpic" style={{ width: '100%', height: '150px' }} />
}

export default Pictorial
